import axios from "axios";

const axiosInstance = axios.create({
  baseURL: 'https://api.industry.dev-iuh.xyz/api/',
});
// https://industreeapi.dev-mm.xyz/api/

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    console.log("Request Interceptor:", config);
    return {
      ...config,
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined
      }
    };
  },

  (error) => {
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something Went Wrong"
    )
);
export default axiosInstance;

// https://docs.google.com/document/d/1MQefrsae8A0OPqqFda69JhU6hDsp6wC0i72h-DRnFxA/edit

